module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_8004.858fb44f.png";